import React from 'react';
import { connect } from 'react-redux';

import CharityListingComponent from '../../components/app/Charity/CharityListing';

import * as actions from '../../actions/charity/charity-listings';

const CharityListing = (props) => {
  return (
    <CharityListingComponent {...props} />
  );
};

export default connect(({ charity, user }) => ({ charityListings: charity.charityListings, user }), actions)(CharityListing);

